import { Component } from '@angular/core';
import { AuthService } from '../../core/auth.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  standalone: true,
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent {
  isLoading = false;

  constructor(private authService: AuthService) {}

  async login(): Promise<void> {
    this.isLoading = true;
    try {
      await this.authService.login(); // chiama loginWithRedirect
    } finally {
      this.isLoading = false;
    }
  }
}
